import React from 'react';
import JudgeNav from '../components/JudgeNav';

const JudgeLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#05339c] flex flex-col md:flex-row">
      {/* Navigation */}
      <JudgeNav />

      {/* Main Content */}
      <main className="flex-1 transition-all duration-300 mt-16 md:mt-0 md:mr-20 lg:mr-64 p-4 md:p-8">
        {children}
      </main>
    </div>
  );
};

export default JudgeLayout;

